// extracted by mini-css-extract-plugin
module.exports = {"root":"FullPageHr_root__z8vr2"};